document.addEventListener('DOMContentLoaded', function () {
    var form = document.querySelector('[data-subscribe-form]');
    if (!form) return;

    var emailInput = form.querySelector('input[name="sf_EMAIL"]');
    var messageBox = form.parentElement.querySelector('.footer__subscribe-message');

    function isValidEmail(value) {
        return value.trim() && value.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
    }

    function showError() {
        if (isValidEmail(emailInput.value)) return;

        messageBox.style.display = 'block';
        messageBox.textContent = 'Введите корректный e-mail';
        messageBox.className = 'footer__subscribe-message footer__subscribe-message--error';
    }

    function hideMessage() {
        messageBox.style.display = 'none';
        messageBox.textContent = '';
        messageBox.className = 'footer__subscribe-message';
    }

    document.addEventListener('click', function (e) {
        if (!form.contains(e.target)) {
            if (emailInput.value.trim() && !isValidEmail(emailInput.value)) {
                showError();
            }
        }
    });

    form.addEventListener('submit', function (e) {
        hideMessage();

        if (!emailInput.value.trim()) {
            e.preventDefault();
            showError();
            emailInput.focus();
            return;
        }

        if (!isValidEmail(emailInput.value)) {
            e.preventDefault();
            showError();
            emailInput.focus();
            return;
        }
    });

    emailInput.addEventListener('input', function () {
        hideMessage();
    });

    emailInput.addEventListener('blur', function () {
        if (emailInput.value.trim() && !isValidEmail(emailInput.value)) {
            showError();
        }
    });
});
